// src/App.js

import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "./Login/Login";
import Dashboard from "./components/Dashboard/Dashboard";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { useAuth, ROLE } from "./context/authContext";

import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

const App = () => {
  const [user, setUser] = useState(null);

  const { role, setRole, isAdmin, loginUser, setLoginUser } = useAuth();

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    const parseStoredUser = JSON.parse(storedUser);
    if (storedUser) {
      setUser(JSON.parse(storedUser));
      setLoginUser(parseStoredUser.name);
      setRole(parseStoredUser.role);
    }
  }, []);



  const handleLogin = (userData) => {
    setRole(userData.role);
    setLoginUser(userData.name);
    localStorage.setItem("user", JSON.stringify(userData));
    setUser(userData);
  };


  

  // Called when logging out
  const handleLogout = () => {
    localStorage.removeItem("user");
    setUser(null);
  };

  return (
    <div>
      <Router>
        <Routes>
          {/* "/" route: if already logged in, go to /dashboard; otherwise show Login */}
          <Route
            path="/"
            element={
              user ? (
                <Navigate to="/dashboard" replace />
              ) : (
                <Login setUser={handleLogin} />
              )
            }
          />

          {/* Protected Dashboard route */}
          <Route
            path="/dashboard"
            element={
              user ? (
                // Pass the entire `user` object + onLogout handler into Dashboard
                <Dashboard user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/" replace />
              )
            }
          />

          {/* Catch-all: redirect unknown paths back to "/" */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default App;
